import React from "react";
import { Col, Row, Container } from "react-bootstrap";
import StoryblokImage from "../../internal/storyblokImage/StoryblokImage";
import {
  BackgroundKeyToColor,
  GeneralSizeKeyToPaddingNumber,
  // GeneralHeightKeyToBarHeight,
} from "../../../utils/datasources";
import { resolveRichText, resolveRichTextWithComponents } from "../../../utils/richText";
import Buttons from "../../internal/buttons/Buttons";
import "./FullWidthColumnCardPanel.scss";
import WidgetWrapper from "../../internal/widgetWrapper/WidgetWrapper";
import useWindowDimensions from "../../../utils/windowDimensions";
import ModalHelper from "../../../utils/modalHelper";

const FullWidthColumnCard = (blok) => {
    const {
        background_color,
        image_right,
        mobile_image,
        cta_link,
        cta_text,
        cta_type,
        header_text,
        is_modal,
        cta_color,
        modal_id,
        modal
      } = blok.blok;
    
      const buttonProps = {
        text: cta_text,
        url: cta_link,
        textColor: cta_color,
        isModal: is_modal,
        modalId: modal_id,
        component: cta_type,
        modal: modal
      };
      // const {width} = useWindowDimensions();
      const width = 1920;
  return (
    <WidgetWrapper blok={blok.blok}>
      <Container className="full-width-column-card full-width-column-card-panel">
        <Row>
          <Col className="justify-content-center left-col" md={12} lg={6}>
          {resolveRichTextWithComponents(header_text)}
            {cta_text ? (
              <div className="general-button-wrapper adjust-space">
                {modal ? <ModalHelper buttonProps={buttonProps} /> : <Buttons buttonProps={buttonProps} />}
                {/* <Buttons buttonProps={buttonProps} /> */}
              </div>
            ) : null}
          </Col>
          <Col className="justify-content-center right-col" md={12} lg={6}>
          {width < 992 && (mobile_image && mobile_image.filename !== "") ? <StoryblokImage sbImageData={mobile_image} /> : <StoryblokImage sbImageData={image_right} />}
          </Col>
        </Row>
      </Container>
    </WidgetWrapper>
  );
};

export default FullWidthColumnCard;
